<template>
  <div class="orderDetail-container">
    <b class="f5">{{ order.customerName }}</b>
    <el-divider></el-divider>

    <span class="label-text">Lokasi Asal</span>
    <br />
    <b>{{ order.originName }}</b>
    <br />
    <span class="label-text">{{ order.originAddress }}</span>
    <br />
    <el-row class="mt2">
      <el-col :span="12">
        <span class="label-text">Nama Pengirim</span>
        <br />
        <span v-text="order.senderName"></span>
      </el-col>
      <el-col :span="12">
        <span class="label-text">No Telpon</span>
        <br />
        <span v-text="order.senderPhone"></span>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <span class="label-text">Lokasi Tujuan</span>
    <br />
    <b>{{ order.destinationName }}</b>
    <br />
    <span class="label-text">{{ order.destinationAddress }}</span>
    <br />
    <el-row class="mt2">
      <el-col :span="12">
        <span class="label-text">Nama Penerima</span>
        <br />
        <span v-text="order.recipientName"></span>
      </el-col>
      <el-col :span="12">
        <span class="label-text">No Telpon</span>
        <br />
        <span v-text="order.recipientPhone"></span>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row class="mt2">
      <el-col :span="12">
        <span class="label-text">Kategori Barang</span>
        <br />
        <span>{{ order.payloadCategory }}</span>
      </el-col>
      <el-col :span="12">
        <span class="label-text">Subkategori Barang</span>
        <br />
        <span>{{ order.payloadSubCategory }}</span>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <span class="label-text">Informasi Tambahan</span>
    <br />
    <span v-text="order.deliveryNote"></span>
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
  name: "order-detail-content",
  props: {
    order: Object,
  },
};
</script>

<style lang="scss" scoped>
.orderDetail {
  &-container {
    @extend .text-left;
    line-height: 20px;
  }
}
.label-text {
  @extend .f7;
  color: $--color-text-gray;
}
</style>
